import React from 'react';
import { motion } from 'framer-motion';
export const AngerMonster = ({
  className
}: {
  className?: string;
}) => <motion.svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" animate={{
  y: [0, -5, 0]
}} transition={{
  repeat: Infinity,
  duration: 2,
  ease: 'easeInOut'
}} data-id="element-128">
    {/* Body */}
    <path d="M20 80 C 20 30, 80 30, 80 80 Z" fill="#E85D4A" data-id="element-129" />
    {/* Eyes (angry) */}
    <path d="M30 45 L 45 50" stroke="#2D3748" strokeWidth="4" strokeLinecap="round" data-id="element-130" />
    <path d="M70 45 L 55 50" stroke="#2D3748" strokeWidth="4" strokeLinecap="round" data-id="element-131" />
    <circle cx="40" cy="55" r="5" fill="#2D3748" data-id="element-132" />
    <circle cx="60" cy="55" r="5" fill="#2D3748" data-id="element-133" />
    {/* Mouth */}
    <path d="M40 70 Q 50 60 60 70" stroke="#2D3748" strokeWidth="4" strokeLinecap="round" data-id="element-134" />
    {/* Smoke */}
    <motion.circle cx="15" cy="40" r="8" fill="#A0AEC0" opacity="0.8" animate={{
    y: [0, -10, 0],
    opacity: [0.8, 0.4, 0.8]
  }} transition={{
    repeat: Infinity,
    duration: 1.5
  }} data-id="element-135" />
    <motion.circle cx="10" cy="25" r="6" fill="#A0AEC0" opacity="0.6" animate={{
    y: [0, -15, 0],
    opacity: [0.6, 0, 0.6]
  }} transition={{
    repeat: Infinity,
    duration: 2
  }} data-id="element-136" />
    <motion.circle cx="85" cy="40" r="8" fill="#A0AEC0" opacity="0.8" animate={{
    y: [0, -10, 0],
    opacity: [0.8, 0.4, 0.8]
  }} transition={{
    repeat: Infinity,
    duration: 1.7
  }} data-id="element-137" />
    <motion.circle cx="90" cy="25" r="6" fill="#A0AEC0" opacity="0.6" animate={{
    y: [0, -15, 0],
    opacity: [0.6, 0, 0.6]
  }} transition={{
    repeat: Infinity,
    duration: 1.9
  }} data-id="element-138" />
    {/* Fists */}
    <circle cx="15" cy="75" r="12" fill="#C53030" data-id="element-139" />
    <circle cx="85" cy="75" r="12" fill="#C53030" data-id="element-140" />
  </motion.svg>;
export const FearMonster = ({
  className
}: {
  className?: string;
}) => <motion.svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" animate={{
  x: [0, -2, 2, -2, 2, 0]
}} transition={{
  repeat: Infinity,
  duration: 3,
  ease: 'easeInOut',
  repeatDelay: 1
}} data-id="element-141">
    {/* Blanket */}
    <path d="M10 90 C 10 20, 90 20, 90 90 Z" fill="#E2E8F0" data-id="element-142" />
    {/* Monster peeking */}
    <path d="M30 60 C 30 30, 70 30, 70 60 Z" fill="#7B61A8" data-id="element-143" />
    {/* Big Eyes */}
    <circle cx="40" cy="45" r="10" fill="white" data-id="element-144" />
    <circle cx="60" cy="45" r="10" fill="white" data-id="element-145" />
    <circle cx="40" cy="45" r="4" fill="#2D3748" data-id="element-146" />
    <circle cx="60" cy="45" r="4" fill="#2D3748" data-id="element-147" />
    {/* Shaking lines */}
    <path d="M20 40 Q 15 45 20 50" stroke="#2D3748" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-148" />
    <path d="M80 40 Q 85 45 80 50" stroke="#2D3748" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-149" />
    <path d="M25 30 Q 20 35 25 40" stroke="#2D3748" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-150" />
    <path d="M75 30 Q 80 35 75 40" stroke="#2D3748" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-151" />
  </motion.svg>;
export const SadnessMonster = ({
  className
}: {
  className?: string;
}) => <motion.svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" animate={{
  y: [0, 3, 0]
}} transition={{
  repeat: Infinity,
  duration: 4,
  ease: 'easeInOut'
}} data-id="element-152">
    {/* Body */}
    <path d="M25 85 C 10 40, 90 40, 75 85 Z" fill="#5B9BD5" data-id="element-153" />
    {/* Droopy Eyes */}
    <path d="M35 45 Q 40 40 45 45" stroke="#2D3748" strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-154" />
    <path d="M65 45 Q 60 40 55 45" stroke="#2D3748" strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-155" />
    <circle cx="40" cy="50" r="4" fill="#2D3748" data-id="element-156" />
    <circle cx="60" cy="50" r="4" fill="#2D3748" data-id="element-157" />
    {/* Tears */}
    <motion.path d="M40 55 Q 40 70 40 70" stroke="#90CDF4" strokeWidth="4" strokeLinecap="round" strokeDasharray="2 6" animate={{
    strokeDashoffset: [0, -20]
  }} transition={{
    repeat: Infinity,
    duration: 2,
    ease: 'linear'
  }} data-id="element-158" />
    <motion.path d="M60 55 Q 60 70 60 70" stroke="#90CDF4" strokeWidth="4" strokeLinecap="round" strokeDasharray="2 6" animate={{
    strokeDashoffset: [0, -20]
  }} transition={{
    repeat: Infinity,
    duration: 2,
    ease: 'linear'
  }} data-id="element-159" />
    {/* Mouth */}
    <path d="M45 65 Q 50 60 55 65" stroke="#2D3748" strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-160" />
    {/* Raindrops */}
    <motion.path d="M20 15 L 15 25" stroke="#4299E1" strokeWidth="3" strokeLinecap="round" animate={{
    y: [0, 10, 0],
    opacity: [1, 0, 1]
  }} transition={{
    repeat: Infinity,
    duration: 1.5
  }} data-id="element-161" />
    <motion.path d="M50 5 L 45 15" stroke="#4299E1" strokeWidth="3" strokeLinecap="round" animate={{
    y: [0, 15, 0],
    opacity: [1, 0, 1]
  }} transition={{
    repeat: Infinity,
    duration: 1.2
  }} data-id="element-162" />
    <motion.path d="M80 15 L 75 25" stroke="#4299E1" strokeWidth="3" strokeLinecap="round" animate={{
    y: [0, 10, 0],
    opacity: [1, 0, 1]
  }} transition={{
    repeat: Infinity,
    duration: 1.8
  }} data-id="element-163" />
  </motion.svg>;
export const HappinessMonster = ({
  className
}: {
  className?: string;
}) => <motion.svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" animate={{
  y: [0, -10, 0],
  rotate: [-2, 2, -2]
}} transition={{
  repeat: Infinity,
  duration: 1.5,
  ease: 'easeInOut'
}} data-id="element-164">
    {/* Sun rays */}
    <motion.circle cx="50" cy="50" r="45" fill="#FEFCBF" opacity="0.6" animate={{
    scale: [1, 1.1, 1]
  }} transition={{
    repeat: Infinity,
    duration: 3
  }} data-id="element-165" />
    {/* Body */}
    <circle cx="50" cy="55" r="35" fill="#FFD93D" data-id="element-166" />
    {/* Happy Eyes */}
    <path d="M35 45 Q 40 35 45 45" stroke="#2D3748" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-167" />
    <path d="M65 45 Q 60 35 55 45" stroke="#2D3748" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-168" />
    {/* Big Smile */}
    <path d="M35 60 Q 50 80 65 60" stroke="#2D3748" strokeWidth="4" strokeLinecap="round" fill="none" data-id="element-169" />
    <path d="M40 65 Q 50 75 60 65" fill="#FC8181" data-id="element-170" />
    {/* Arms dancing */}
    <motion.path d="M15 55 Q 5 35 15 25" stroke="#FFD93D" strokeWidth="10" strokeLinecap="round" fill="none" animate={{
    rotate: [-10, 10, -10],
    originX: 0.15,
    originY: 0.55
  }} transition={{
    repeat: Infinity,
    duration: 1
  }} data-id="element-171" />
    <motion.path d="M85 55 Q 95 35 85 25" stroke="#FFD93D" strokeWidth="10" strokeLinecap="round" fill="none" animate={{
    rotate: [10, -10, 10],
    originX: 0.85,
    originY: 0.55
  }} transition={{
    repeat: Infinity,
    duration: 1
  }} data-id="element-172" />
  </motion.svg>;
export const CalmMonster = ({
  className
}: {
  className?: string;
}) => <motion.svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" animate={{
  y: [0, -3, 0]
}} transition={{
  repeat: Infinity,
  duration: 4,
  ease: 'easeInOut'
}} data-id="element-173">
    {/* Body */}
    <path d="M25 85 C 25 40, 75 40, 75 85 Z" fill="#4ECDC4" data-id="element-174" />
    {/* Closed Eyes */}
    <path d="M35 55 Q 42 60 48 55" stroke="#2D3748" strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-175" />
    <path d="M65 55 Q 58 60 52 55" stroke="#2D3748" strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-176" />
    {/* Gentle smile */}
    <path d="M45 70 Q 50 75 55 70" stroke="#2D3748" strokeWidth="3" strokeLinecap="round" fill="none" data-id="element-177" />
    {/* Zen Arms */}
    <path d="M25 65 Q 15 65 20 75" stroke="#4ECDC4" strokeWidth="8" strokeLinecap="round" fill="none" data-id="element-178" />
    <path d="M75 65 Q 85 65 80 75" stroke="#4ECDC4" strokeWidth="8" strokeLinecap="round" fill="none" data-id="element-179" />
    {/* Leaves/Wind */}
    <motion.path d="M10 45 Q 20 35 30 40" stroke="#81E6D9" strokeWidth="3" strokeLinecap="round" fill="none" animate={{
    x: [-5, 5, -5],
    opacity: [0.5, 1, 0.5]
  }} transition={{
    repeat: Infinity,
    duration: 3
  }} data-id="element-180" />
    <motion.path d="M90 35 Q 80 25 70 30" stroke="#81E6D9" strokeWidth="3" strokeLinecap="round" fill="none" animate={{
    x: [5, -5, 5],
    opacity: [0.5, 1, 0.5]
  }} transition={{
    repeat: Infinity,
    duration: 3.5
  }} data-id="element-181" />
  </motion.svg>;